var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-ment-body"},[_c('el-steps',{attrs:{"active":_vm.step,"finish-status":"success","simple":""}},[_c('el-step',{attrs:{"title":"确认订单"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"支付"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"支付成功"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/Payment/components/private-component/Steps.vue